/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * <p>
 * Copyright © 2019 Pearson Education, Inc.
 * All Rights Reserved.
 * <p>
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained from Pearson Education, Inc.
 *
 * This is the data class for holding partner attributes.
 *
 * @author urahish
 * 12/13/2019
 *
 */

import React, {useState} from "react";
import Popup from "reactjs-popup";
import Icon from "../icon/Icon";
import EventEmitter from "../../../eventEmmiters/EventEmitter";

const TableColumnViewer = (prop) => {
    const [openTableColumnViewer, setOpenTableColumnViewer] = useState(false);
    const [tableColumnViewerData, setTableColumnViewerData] = useState({});

    const openModel = (data) => {
        setOpenTableColumnViewer(data)
    };
    EventEmitter.on('openTableColumnViewer', openModel);
    const setModelData = (data) => {
        setTableColumnViewerData(data)
    };
    EventEmitter.on('tableColumnViewerData', setModelData);

    const closeTableColumnViewer = () => {
        setOpenTableColumnViewer(false);
    };

    let modalContent = null;

    if (tableColumnViewerData !== undefined)
        modalContent =
            <div className="column-container">
                <h5>Please select columns to display</h5>
                <div className="column-items">
                    {tableColumnViewerData.data}
                </div>
            </div>;
    else
        modalContent = <h5>No Data to display</h5>;

    return(
        <Popup open={openTableColumnViewer} onClose={closeTableColumnViewer}>
            <div>
                <button style={{position: 'absolute',top: 0, right: 0}} className="pe-icon--btn static-close-title"
                        onClick={() => closeTableColumnViewer()}
                        aria-label="Close warning">
                    <Icon name="remove-sm-24"/>
                </button>
                {modalContent}
            </div>
        </Popup>
    );
};

export default TableColumnViewer;
